import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app'
import 'firebase/auth'
import VueCurrencyFilter from 'vue-currency-filter'

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: 'AIzaSyD5h_lGYWsI754q8ceAJSajxZ0b2toC-sY',
  authDomain: 'tquoter-678df.firebaseapp.com',
  databaseURL: 'https://tquoter-678df.firebaseio.com',
  projectId: 'tquoter-678df',
  storageBucket: 'tquoter-678df.appspot.com',
  messagingSenderId: '634077142159',
  appId: '1:634077142159:web:82b57d6e72449f02'
}

if (firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig)
}

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    router.replace('/')
  } else {
    router.replace('/login')
    // router.go('/login')
  }
})

Vue.use(VueCurrencyFilter,
  {
    symbol: '$',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: true
  })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
